import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  createSpecialOffer,
  resetSpecialSuccess,
} from "../../../features/reservationSlice";
import { updateUser } from "../../../features/userSlice";
import "../../../pages/Reservation/Reservation.css";

import vinilImg from "../../../assets/img/vinil-room.png";
import radiolaImg from "../../../assets/img/radiola_room.jpg";
import discoImg from "../../../assets/img/discopolaroin_in.jpg";
import livImg from "../../../assets/img/mg_in.jpg";
import bgImg from "../../../assets/img/bg_card1.jpg";
import residenceImg from "../../../assets/img/residence_card1.jpg";
import vinilStory1 from "../../../assets/img/Vinil/vinil_1.jpg";
import vinilStory2 from "../../../assets/img/Vinil/vinil_2.jpg";
import vinilStory2_5 from "../../../assets/img/Vinil/vinil_2.5.jpg";
import vinilStory3 from "../../../assets/img/Vinil/vinil_3.jpg";
// import vinilStory4 from "../../../assets/img/Vinil/vinil_4.jpg";
import vinilStory5 from "../../../assets/img/Vinil/vinil_5.jpg";
import radiolaStory1 from "../../../assets/img/Radiola/radiola_1.jpg";
import radiolaStory2 from "../../../assets/img/Radiola/radiola_2.jpg";
import radiolaStory3 from "../../../assets/img/Radiola/radiola_3.jpg";
import radiolaStory4 from "../../../assets/img/Radiola/radiola_4.jpg";
import radiolaStory5 from "../../../assets/img/Radiola/radiola_5.jpg";

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { translations, normalizeLang } from "../../../i18n";


const formatPhoneDisplay = (value) => {
  const digits = value.replace(/\D/g, "").replace(/^7/, "");
  const clean = digits.slice(0, 10);
  let formatted = "+7";
  if (clean.length > 0) formatted += ` (${clean.slice(0, 3)}`;
  if (clean.length >= 4) formatted += `) ${clean.slice(3, 6)}`;
  if (clean.length >= 7) formatted += `-${clean.slice(6, 8)}`;
  if (clean.length >= 9) formatted += `-${clean.slice(8, 10)}`;
  return formatted;
};

const checkDate = (val, t) => {
  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(val)) return t.dateFormatError;
  const [d, m, y] = val.split(".").map(Number);
  const dt = new Date(y, m - 1, d);
  if (dt.getDate() !== d || dt.getMonth() !== m - 1 || dt.getFullYear() !== y) {
    return t.dateInvalidError;
  }
  return "";
};

const formatDate = (dateObj) => {
  if (!dateObj) return "";
  const d = String(dateObj.getDate()).padStart(2, "0");
  const m = String(dateObj.getMonth() + 1).padStart(2, "0");
  const y = dateObj.getFullYear();
  return `${d}.${m}.${y}`;
};

const checkGuests = (val, t) => (!/^\d+$/.test(val) ? t.guestsOnlyDigitsError : "");

const checkDescription = (val, t) =>
  val && val.trim().length > 0 ? "" : t.descriptionRequiredError;

const checkTime = (val, t) => {
  if (!/^\d{2}:\d{2}$/.test(val)) return t.timeFormatError;
  const [h, m] = val.split(":").map(Number);
  return h > 23 || m > 59 ? t.timeInvalidError : "";
};

const checkDuration = (val, t) =>
  !/^\d+$/.test(val) || +val < 1 || +val > 24 ? t.durationErrorText : "";

const getBookingWeekday = (dateStr) => {
  const [d, m, y] = dateStr.split(".").map(Number);
  const bookingDate = new Date(y, m - 1, d);
  return bookingDate.getDay();
};

const isAllowedBookingTime = (dateStr, timeStr) => {
  const [h, min] = timeStr.split(":").map(Number);
  const totalMinutes = h * 60 + min;
  const day = getBookingWeekday(dateStr);

  const isEarlyEnough =
    (day >= 0 && day <= 4 && totalMinutes <= 75) ||
    (day >= 5 && totalMinutes <= 195);

  const isLateEnough = totalMinutes >= 12 * 60;

  return isEarlyEnough || isLateEnough;
};

const loadedRoomImgCache = new Map();
const CAROUSEL_SLIDE_MS = 320;

function RoomCachedImg({
  src,
  alt = "",
  className = "res__img",
  fit = "cover",
}) {
  const isCached = loadedRoomImgCache.get(src)?.status === "loaded";
  const [loaded, setLoaded] = useState(isCached);

  useEffect(() => {
    if (isCached) return;

    let cancelled = false;
    const img = new Image();
    img.src = src;

    const finalize = (status) => {
      if (cancelled) return;
      loadedRoomImgCache.set(src, { status });
      setLoaded(status === "loaded");
    };

    img.onload = async () => {
      try {
        if (img.decode) await img.decode();
      } catch {}
      finalize("loaded");
    };
    img.onerror = () => finalize("error");

    return () => {
      cancelled = true;
    };
  }, [src, isCached]);

  const showSkeleton = !loaded && !isCached;
  const transition = !isCached ? "opacity 0.2s ease-out" : "none";

  return (
    <>
      {showSkeleton && (
        <div className={`${className}-skeleton`} aria-hidden="true" />
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        style={{
          objectFit: fit,
          margin: 0,
          opacity: loaded ? 1 : 0,
          transition,
        }}
        loading="eager"
        decoding="async"
      />
    </>
  );
}

const Room = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];
  const { loading: spLoading, success: spSuccess } = useSelector(
    (s) => s.reservation.special
  );

  const roomText = {
    vinil: t.vinil,
    radiola: t.radiola,
    livingrm: t.livingrm,
    disco: t.disco,
    bigliving: t.bigliving,
    residence: t.Residence,
  };

  const roomPassword = {
    vinil: "Vynilroom",
    radiola: "Radiolaroom",
    livingrm: "musieresidence",
    disco: "musieresidence",
    bigliving: "musieresidence",
    residence: "musieresidence",
  };

  const wifiName = {
    vinil: "MusieResidence_Vynil",
    radiola: "MusieResidence_Radiola",
    livingrm: "MusieResidence_Guest",
    disco: "MusieResidence_Guest",
    bigliving: "MusieResidence_Guest",
    residence: "MusieResidence_Guest",
  };

  const roomImages = {
    vinil: vinilImg,
    radiola: radiolaImg,
    livingrm: livImg,
    disco: discoImg,
    bigliving: bgImg,
    residence: residenceImg,
  };

  const roomGalleries = {
    vinil: [
      vinilStory1,
      vinilStory2,
      vinilStory2_5,
      vinilStory3,
      vinilImg,
      vinilStory5,
    ],
    radiola: [
      radiolaStory1,
      radiolaStory2,
      radiolaStory3,
      radiolaStory4,
      radiolaStory5,
    ],
    bigliving: [bgImg],
    residence: [residenceImg],
  };

  const [bookingName, setBookingName] = useState("");
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [guests, setGuests] = useState("");
  const [time, setTime] = useState("");
  const [defaultTime, setDefaultTime] = useState("");
  const [duration, setDuration] = useState("");
  const [description, setDescription] = useState("");
  const [timeTouched, setTimeTouched] = useState(false);
  const [descTouched, setDescTouched] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [galleryAnimation, setGalleryAnimation] = useState({
    prevIndex: null,
    direction: 1,
    phase: "idle",
  });
  const [errors, setErrors] = useState({
    date: "",
    guests: "",
    time: "",
    duration: "",
    description: "",
  });

  const phoneInitialized = useRef(false);
  const bookingNameInitialized = useRef(false);

  const activeGallery = Array.isArray(roomGalleries[id])
    ? roomGalleries[id]
    : null;
  const canCycleGallery = activeGallery?.length > 1;
  const activeRoomImage =
    activeGallery?.length > 0
      ? activeGallery[galleryIndex % activeGallery.length]
      : roomImages[id];
  const previousRoomImage =
    galleryAnimation.prevIndex !== null && activeGallery?.length
      ? activeGallery[galleryAnimation.prevIndex % activeGallery.length]
      : null;
  const isGalleryAnimating =
    canCycleGallery &&
    galleryAnimation.prevIndex !== null &&
    galleryAnimation.phase !== "idle";

  useEffect(() => {
    if (!activeGallery || !Array.isArray(activeGallery)) return;

    activeGallery.forEach((src) => {
      const cached = loadedRoomImgCache.get(src);
      if (cached && cached.status === "loaded") return;

      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedRoomImgCache.set(src, { status: "loaded" });
      };
    });
  }, [activeGallery]);

  useEffect(() => {
    setGalleryIndex(0);
    setGalleryAnimation({
      prevIndex: null,
      direction: 1,
      phase: "idle",
    });
  }, [id]);

  useEffect(() => {
    if (galleryAnimation.phase === "prepare") {
      const frame = requestAnimationFrame(() => {
        setGalleryAnimation((state) =>
          state.phase === "prepare" ? { ...state, phase: "active" } : state
        );
      });
      return () => cancelAnimationFrame(frame);
    }
    if (galleryAnimation.phase === "active") {
      const timer = setTimeout(() => {
        setGalleryAnimation((state) =>
          state.phase === "active"
            ? { prevIndex: null, direction: state.direction, phase: "idle" }
            : state
        );
      }, CAROUSEL_SLIDE_MS);
      return () => clearTimeout(timer);
    }
  }, [galleryAnimation]);

  const triggerGalleryMove = (direction) => {
    if (!canCycleGallery) return;
    if (galleryAnimation.phase !== "idle") return;
    const galleryLength = activeGallery.length;
    setGalleryAnimation({
      prevIndex: galleryIndex,
      direction,
      phase: "prepare",
    });
    setGalleryIndex(
      (prev) => (prev + direction + galleryLength) % galleryLength
    );
  };

  const handleGalleryArrow = (event, direction) => {
    event.stopPropagation();
    triggerGalleryMove(direction);
  };

  useEffect(() => {
    if (
      (id === "livingrm" ||
        id === "disco" ||
        id === "bigliving" ||
        id === "residence") &&
      !date &&
      !time
    ) {
      const now = new Date(Date.now() + 15 * 60 * 1000);
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      setDate(`${dd}.${mm}.${yyyy}`);

      const initialTime = `${String(now.getHours()).padStart(2, "0")}:${String(
        now.getMinutes()
      ).padStart(2, "0")}`;
      if (!isAllowedBookingTime(`${dd}.${mm}.${yyyy}`, initialTime)) {
        setDefaultTime("12:00");
      } else {
        setDefaultTime(initialTime);
      }
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      (id === "livingrm" ||
        id === "disco" ||
        id === "bigliving" ||
        id === "residence") &&
      !bookingNameInitialized.current &&
      user?.firstName
    ) {
      setBookingName(user.firstName);
      bookingNameInitialized.current = true;
    }
  }, [user?.firstName, id]);

  useEffect(() => {
    if (
      (id === "livingrm" ||
        id === "disco" ||
        id === "bigliving" ||
        id === "residence") &&
      !phoneInitialized.current &&
      user?.phone
    ) {
      const dig = user.phone.replace(/\D/g, "").replace(/^7/, "").slice(0, 10);
      setPhone(dig);
      phoneInitialized.current = true;
    }
  }, [user?.phone, id]);

  useEffect(() => {
    if (
      id === "livingrm" ||
      id === "disco" ||
      id === "bigliving" ||
      id === "residence"
    ) {
      setErrors({
        date: date ? checkDate(date, t) : "",
        guests: guests ? checkGuests(guests, t) : "",
        time: time ? checkTime(time, t) : "",
        duration: duration ? checkDuration(duration, t) : "",
        description: checkDescription(description, t),
      });
    }
  }, [date, guests, time, duration, description, id, t]);

  useEffect(() => {
    if (
      (id === "livingrm" ||
        id === "disco" ||
        id === "bigliving" ||
        id === "residence") &&
      submitAttempted &&
      (bookingName.trim() ||
        phone.length === 10 ||
        date ||
        guests ||
        time ||
        duration ||
        description.trim())
    ) {
      const timer = setTimeout(() => {
        setSubmitAttempted(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [
    bookingName,
    phone,
    date,
    guests,
    time,
    duration,
    description,
    submitAttempted,
    id,
  ]);

  const handleReservation = () => {
    setSubmitAttempted(true);
    if (!user?.telegramId) return;

    const bookingNameValid = bookingName.trim().length > 0;
    const phoneValid = phone.length === 10;
    const dateValid = date && !checkDate(date, t);
    const guestsValid = guests && !checkGuests(guests, t);
    const timeValid =
      time && !checkTime(time, t) && isAllowedBookingTime(date, time);
    const durationValid = duration && !checkDuration(duration, t);
    const descriptionValid = description.trim().length > 0;

    if (
      !bookingNameValid ||
      !phoneValid ||
      !dateValid ||
      !guestsValid ||
      !timeValid ||
      !durationValid ||
      !descriptionValid
    ) {
      return;
    }

    const roomLabel = t.roomNames[id] || "";
    const trimmedDescription = description.trim().replace(/[<>&"']/g, "");
    const finalDescription = trimmedDescription
      ? roomLabel
        ? `${roomLabel}: ${trimmedDescription}`
        : trimmedDescription
      : roomLabel;
    const formattedPhone = formatPhoneDisplay(phone);
    const offerData = {
      bookingName: bookingName.trim().replace(/[<>&"']/g, ""),
      phone: formattedPhone,
      date,
      guests,
      time,
      duration,
      description: finalDescription,
    };
    dispatch(createSpecialOffer({ telegramId: user.telegramId, offerData }));
  };

  useEffect(() => {
    if (
      spSuccess &&
      user?.telegramId &&
      (id === "livingrm" ||
        id === "disco" ||
        id === "bigliving" ||
        id === "residence")
    ) {
      const formattedPhone = formatPhoneDisplay(phone);
      const roomLabel = t.roomNames[id] || "";
      const trimmedDescription = description.trim();
      const finalDescription = trimmedDescription
        ? roomLabel
          ? `${roomLabel}: ${trimmedDescription}`
          : trimmedDescription
        : roomLabel;
      dispatch(
        updateUser({
          ...user,
          phone: formattedPhone,
          lastOrder: {
            phone: formattedPhone,
            date,
            guests,
            time,
            duration,
            description: finalDescription,
          },
        })
      );

      setSubmitAttempted(false);
    }
  }, [spSuccess, dispatch, user?.telegramId, id]); // eslint-disable-line

  useEffect(() => {
    return () => {
      dispatch(resetSpecialSuccess());
    };
  }, [dispatch]);

  return (
    <div>
      <div style={{ fontSize: "12px", margin: "0 15px", display: "flex" }}>
        <svg
          style={{ marginRight: "5px" }}
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 0C3.35775 0 0 3.35775 0 7.5C0 11.6422 3.35775 15 7.5 15C11.6422 15 15 11.6422 15 7.5C15 3.35775 11.6422 0 7.5 0ZM7.5 1.5C8.49 1.5 9.5775 3.77401 9.74325 6.74776L5.26575 6.75675C5.43075 3.783 6.51 1.5 7.5 1.5ZM4.85175 2.10226C4.20675 3.35701 3.86175 5.02051 3.7785 6.75151L1.54351 6.74476C1.76701 4.70101 3.14325 2.98651 4.85175 2.10226ZM10.152 2.10601C11.8605 2.99026 13.2015 4.65675 13.4602 6.75675L11.226 6.75C11.1555 4.95 10.7573 3.36751 10.152 2.10601ZM1.548 8.253L3.78225 8.23425C3.8655 9.96525 4.21274 11.6572 4.85474 12.8985C3.06074 11.9992 1.806 10.239 1.548 8.253ZM5.25375 8.259L9.73125 8.24924C9.56625 11.2222 8.49 13.5 7.5 13.5C6.51 13.5 5.41875 11.2327 5.25375 8.259ZM11.2297 8.25151L13.4542 8.24476C13.1962 10.2315 11.9423 12.006 10.149 12.8903C10.815 11.5133 11.1465 9.98251 11.2297 8.25151Z"
            fill="black"
          />
        </svg>
        <p>{t.roomNames[id]}</p>
      </div>
      <div className="res__contents">
        <div className="res__content">
          <div
            className="res__img-wrapper"
            style={{
              cursor: "default",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                overflow: "hidden",
              }}
            >
              {isGalleryAnimating && previousRoomImage && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    transform:
                      galleryAnimation.phase === "active"
                        ? `translateX(${
                            galleryAnimation.direction === 1 ? -100 : 100
                          }%)`
                        : "translateX(0%)",
                    transition:
                      galleryAnimation.phase === "prepare"
                        ? "none"
                        : `transform ${CAROUSEL_SLIDE_MS}ms ease`,
                    pointerEvents: "none",
                    backfaceVisibility: "hidden",
                    WebkitBackfaceVisibility: "hidden",
                    willChange: "transform",
                  }}
                >
                  <RoomCachedImg src={previousRoomImage} alt={t.roomNames[id]} />
                </div>
              )}
              <div
                style={{
                  position: isGalleryAnimating ? "absolute" : "relative",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  transform: isGalleryAnimating
                    ? galleryAnimation.phase === "prepare"
                      ? `translateX(${
                          galleryAnimation.direction === 1 ? 100 : -100
                        }%)`
                      : "translateX(0%)"
                    : "translateX(0%)",
                  transition:
                    !isGalleryAnimating || galleryAnimation.phase === "prepare"
                      ? "none"
                      : `transform ${CAROUSEL_SLIDE_MS}ms ease`,
                  pointerEvents: "none",
                  backfaceVisibility: "hidden",
                  WebkitBackfaceVisibility: "hidden",
                  willChange: "transform",
                }}
              >
                <RoomCachedImg src={activeRoomImage} alt={t.roomNames[id]} />
              </div>
            </div>

            {canCycleGallery && (
              <>
                <button
                  type="button"
                  onClick={(event) => handleGalleryArrow(event, -1)}
                  aria-label={t.ariaPrevPhoto}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "12px",
                    transform: "translateY(-50%)",
                    background: "rgba(0, 0, 0, 0.35)",
                    border: "none",
                    color: "white",
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 2,
                    backdropFilter: "blur(6px)",
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                </button>
                <button
                  type="button"
                  onClick={(event) => handleGalleryArrow(event, 1)}
                  aria-label={t.ariaNextPhoto}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "12px",
                    transform: "translateY(-50%)",
                    background: "rgba(0, 0, 0, 0.35)",
                    border: "none",
                    color: "white",
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 2,
                    backdropFilter: "blur(6px)",
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              </>
            )}

            <div className="rooms__text" style={{ margin: "12px" }}>
              {id !== "livingrm" &&
                id !== "disco" &&
                id !== "bigliving" &&
                id !== "residence" && (
                  <div
                    style={{
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      style={{ marginRight: "8px" }}
                      width="16"
                      height="20"
                      viewBox="0 0 16 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.76 2.5V10H8.70272C11.4342 10 12.8 8.54 12.8 6.23562C12.8 3.94562 11.4342 2.5 8.7168 2.5H5.76ZM9.54688 12.585H5.85152V15.325H11.4643V16.9206H5.85152V20H2.75776V16.9206H0V15.325H2.75776V12.585H0V10.9744H2.75776V0H9.6448C13.4944 0 16 2.68375 16 6.31375C16 9.92937 13.4381 12.585 9.54688 12.585Z"
                        fill="white"
                      />
                    </svg>
                    <div>
                      <p style={{ fontWeight: "500", opacity: "0.6" }}>
                        {t.pricePerHourLabel}
                      </p>
                      <p>{t.pricePerHourValue}</p>
                    </div>
                  </div>
                )}
            </div>
            <div className="res__img-overlay" />
          </div>
          <div
            className="res__text"
            style={{ opacity: "0.8", fontSize: "14px", color: "#222" }}
          >
            {roomText[id].map((paragraph, index) => (
              <p key={index} style={{ marginBottom: "10px" }}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        <div
          className="res__text"
          style={{ marginTop: "5px", fontSize: "13px" }}
        >
          <p>
            {t.wifiLabel} <span style={{ opacity: "0.6" }}>{wifiName[id]}</span>
          </p>
          <p>
            {t.passwordLabel} <span style={{ opacity: "0.6" }}>{roomPassword[id]}</span>
          </p>
        </div>

        {(id === "livingrm" ||
          id === "disco" ||
          id === "bigliving" ||
          id === "residence") && (
          <div style={{ margin: "20px 0px" }} className="reservContainer">
            <div className="reservDescription">
              <svg
                className="reservDescriptionIcon"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.977974"
                  d="M3.15599 0C1.41309 0 0 1.4925 0 3.33333V11.6667C0 13.5075 1.41309 15 3.15599 15H11.0459C12.7888 15 14.2019 13.5075 14.2019 11.6667V8.33333C14.2019 7.87333 13.8485 7.5 13.4129 7.5C12.9774 7.5 12.6239 7.87333 12.6239 8.33333V11.6667C12.6239 12.5875 11.9178 13.3333 11.0459 13.3333H3.15599C2.28414 13.3333 1.57799 12.5875 1.57799 11.6667V3.33333C1.57799 2.4125 2.28414 1.66667 3.15599 1.66667H9.46796C9.90348 1.66667 10.257 1.29333 10.257 0.833333C10.257 0.373333 9.90348 0 9.46796 0H3.15599ZM14.2019 0.833333C14 0.833333 13.7885 0.908338 13.6347 1.0675L6.75538 8.20333C6.55261 8.41416 6.34826 8.39917 6.18888 8.15084L5.39989 6.92668C5.15845 6.55084 4.65193 6.44167 4.29057 6.6925C3.92842 6.94334 3.82664 7.4625 4.06807 7.83834L4.85707 9.0625C5.56795 10.17 6.95894 10.3167 7.8655 9.375L14.7692 2.21334C15.0769 1.89417 15.0769 1.3875 14.7692 1.0675C14.6154 0.907505 14.4039 0.833333 14.2019 0.833333Z"
                  fill="black"
                />
              </svg>
              <p className="reservDescriptionIconP">
                {t.sendRequestPrefix} {t.roomNames2[id]}
              </p>
            </div>

            <div className="reservContent">
              <div className="inputContent" style={{ marginTop: "15px" }}>
                <label
                  className={
                    submitAttempted && !bookingName.trim() ? "error" : ""
                  }
                >
                  {submitAttempted && !bookingName.trim()
                    ? t.bookingNameError
                    : t.bookingNameLabel}
                </label>
                <input
                  value={bookingName}
                  onChange={(e) => setBookingName(e.target.value)}
                  placeholder={t.bookingNamePlaceholder}
                />
              </div>

              <div className="inputContent">
                <label
                  className={
                    submitAttempted && phone.length !== 10 ? "error" : ""
                  }
                >
                  {submitAttempted && phone.length !== 10
                    ? t.phoneError
                    : t.phoneLabel}
                </label>
                <input
                  value={formatPhoneDisplay(phone)}
                  onChange={(e) => {
                    const dig = e.target.value
                      .replace(/\D/g, "")
                      .replace(/^7/, "")
                      .slice(0, 10);
                    setPhone(dig);
                  }}
                  placeholder={t.phonePlaceholder}
                />
              </div>

              <div className="inputContent">
                <label
                  className={
                    errors.date || (submitAttempted && !date) ? "error" : ""
                  }
                >
                  {errors.date ||
                    (submitAttempted && !date
                      ? t.dateLabel
                      : t.dateLabel)}
                </label>
                <Flatpickr
                  value={date}
                  onChange={([date]) => setDate(formatDate(date))}
                  options={{
                    locale: Russian,
                    dateFormat: "d.m.Y",
                    disableMobile: "true",
                    minDate: "today",
                  }}
                  placeholder={t.datePlaceholder}
                />
              </div>

              <div className="inputContent">
                <label
                  className={
                    errors.guests || (submitAttempted && !guests) ? "error" : ""
                  }
                >
                  {errors.guests ||
                    (submitAttempted && !guests
                      ? t.guestsError
                      : t.guestsLabel)}
                </label>
                <input
                  value={guests}
                  onChange={(e) => setGuests(e.target.value)}
                  placeholder={t.guestsPlaceholder}
                />
              </div>

              <div className="inputContent">
                <label
                  className={
                    (timeTouched || submitAttempted) &&
                    (errors.time ||
                      (checkTime(time, t) === "" &&
                        time &&
                        !isAllowedBookingTime(date, time)) ||
                      (submitAttempted && !time))
                      ? "error"
                      : ""
                  }
                >
                  {timeTouched || submitAttempted
                    ? errors.time
                      ? errors.time
                      : checkTime(time, t) === "" &&
                        time &&
                        !isAllowedBookingTime(date, time)
                      ? t.timeNotWorkingError
                      : submitAttempted && !time
                      ? t.timeError
                      : t.timeLabel
                    : t.timeLabel}
                </label>
                <input
                  value={time}
                  onChange={(e) => {
                    setTime(e.target.value);
                    setTimeTouched(false);
                  }}
                  onBlur={() => setTimeTouched(true)}
                  placeholder={`${t.timePlaceholderPrefix} ${defaultTime}`}
                />
              </div>

              <div className="inputContent">
                <label
                  className={
                    errors.duration || (submitAttempted && !duration)
                      ? "error"
                      : ""
                  }
                >
                  {errors.duration ||
                    (submitAttempted && !duration
                      ? t.durationError
                      : t.durationLabel)}
                </label>
                <input
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  placeholder={t.durationPlaceholder}
                />
              </div>

              <div className="inputContent">
                <label>{t.roomLabel}</label>
                <input
                  value={t.roomNames[id] || ""}
                  readOnly={true}
                  style={{ pointerEvents: "none" }}
                  placeholder={t.roomPlaceholder}
                />
              </div>

              <div className="inputContent">
                <label
                  className={
                    (descTouched || submitAttempted) && errors.description
                      ? "error"
                      : ""
                  }
                >
                  {(descTouched || submitAttempted) && errors.description
                    ? errors.description
                    : t.descriptionLabel}
                </label>
                <input
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onBlur={() => setDescTouched(true)}
                  placeholder={t.descriptionPlaceholder}
                />
              </div>

              <button
                className="reservButton"
                style={{ background: "#366091" }}
                onClick={handleReservation}
                disabled={spLoading || spSuccess}
              >
                {spLoading ? (
                  t.sending
                ) : spSuccess ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ marginRight: 6 }}
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p>{t.sent}</p>
                  </div>
                ) : (
                  t.send
                )}
              </button>
            </div>
          </div>
        )}

        {id !== "livingrm" &&
          id !== "disco" &&
          id !== "bigliving" &&
          id !== "residence" && (
            <Link
              to={`/reservation?room=${[id]}`}
              style={{
                backgroundColor: "#366091",
                padding: "15px",
                color: "white",
                fontWeight: "400",
                fontSize: "12px",
                textAlign: "center",
                marginTop: "10px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                style={{ marginRight: "10px" }}
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.977974"
                  d="M2.94559 0C1.31889 0 0 1.393 0 3.11111V10.8889C0 12.607 1.31889 14 2.94559 14H10.3096C11.9363 14 13.2551 12.607 13.2551 10.8889V7.77778C13.2551 7.34844 12.9252 7 12.5187 7C12.1123 7 11.7823 7.34844 11.7823 7.77778V10.8889C11.7823 11.7483 11.1233 12.4444 10.3096 12.4444H2.94559C2.13187 12.4444 1.47279 11.7483 1.47279 10.8889V3.11111C1.47279 2.25167 2.13187 1.55556 2.94559 1.55556H8.83676C9.24325 1.55556 9.57316 1.20711 9.57316 0.777778C9.57316 0.348444 9.24325 0 8.83676 0H2.94559ZM13.2551 0.777778C13.0666 0.777778 12.8693 0.847782 12.7257 0.996338L6.30503 7.65644C6.11577 7.85322 5.92504 7.83923 5.77629 7.60745L5.03989 6.4649C4.81456 6.11412 4.3418 6.01223 4.00453 6.24634C3.66652 6.48045 3.57153 6.965 3.79687 7.31578L4.53326 8.45833C5.19676 9.492 6.49501 9.62889 7.34113 8.75L13.7846 2.06578C14.0718 1.76789 14.0718 1.295 13.7846 0.996338C13.641 0.847005 13.4437 0.777778 13.2551 0.777778Z"
                  fill="white"
                />
              </svg>
              <p>{t.bookPrefix} {t.roomNames[id]}</p>
            </Link>
          )}
      </div>
    </div>
  );
};

export default Room;
